// @flow

import React from 'react';
import type { Node } from 'react';
import { Link, withRouter } from 'react-router';

type ToType = {
  pathname: string,
  query: string,
  state: Object,
}

type Props = {
  onClick: Function,
  router: Function,
  params: Function,
  location: Function,
  routes: Array<Object>,
  state: Object,
  to: ToType,
  children: Node,
};

class LinkReplace extends React.PureComponent<Props> {
  static defaultProps = {
    onClick: () => {},
    state: undefined,
  };

  render() {
    const { params, location, routes, onClick, state, router, ...props } = this.props;
    const toIsObject = typeof props.to === 'object';
    const pathname = toIsObject ? props.to.pathname : props.to;
    const query = toIsObject ? props.to.query : undefined;

    // This fixes a bug where state was being passed within to prop in the
    // Marketplace id-verify bound routes. e.g.
    // <LinkButton to={{ state: { fromIdStart: true } }} />
    const actualState = toIsObject ? props.to.state : state;

    return (
      <Link
        {...props}
        onClick={(e) => {
          e.preventDefault();
          onClick();
          router.replace({
            pathname,
            state: actualState,
            query,
          });
        }}>
        {props.children}
      </Link>
    );
  }
}

export default withRouter(LinkReplace);
